import { FormikInput } from "@src/components/forms/FormikInput";
import { HeaderText } from "@src/components/general/HeaderText";
import { VerticalFlexbox } from "@src/components/layout/Flexbox";
import { useFormikWizard } from "@src/components/layout/Wizard";
import { Button } from "@src/components/ui/button";
import { navigation } from "@src/navigation";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router";
import { AccountCreate } from "../CreateAccount.types";

export const AccountCredentialsStep = () => {
  const { isSubmitting } = useFormikContext<AccountCreate>();
  const navigate = useNavigate();

  useFormikWizard<AccountCreate>({
    formikFields: ["email", "password", "npi"],
  });

  return (
    <VerticalFlexbox gap="md">
      <HeaderText tag="h2" fontWeight={600}>
        Account Credentials
      </HeaderText>
      <FormikInput
        name="email"
        label="Email"
        type="email"
        autoComplete="email"
        required
      />
      <FormikInput
        name="password"
        label="Password"
        type="password"
        autoComplete="new-password"
        required
      />
      <FormikInput name="npi" label="NPI" />
      <FormikInput name="timezone" label="Timezone (optional)" />
      <VerticalFlexbox className="pt-1">
        <Button
          type="button"
          variant="ghost"
          onClick={() => navigate(navigation.login())}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
      </VerticalFlexbox>
    </VerticalFlexbox>
  );
};
